import { useContext } from 'react';
import { CampaignContext, CampaignContextType } from './CampaignContextDefinition';

export const useCampaign = (): CampaignContextType => {
    const context = useContext(CampaignContext);
    if (!context) {
        throw new Error('useCampaign must be used within a CampaignProvider');
    }
    return context;
};
